import type VueI18n from 'vue-i18n'

import CN from './cn.json'
import EN from './en.json'
import TW from './tw.json'
import JP from './jp.json'

const locales = [
    ['cn', CN],
    ['en', EN],
    ['tw', TW],
    ['jp', JP],
    ['zh-CN', CN],
    ['en-US', EN],
    ['zh-TW', TW],
    ['ja-JP', JP],
]

let currentLocal = 'cn';

export function registerI18n(i18n: VueI18n) {
    currentLocal = i18n.locale;
    locales.forEach(([locale, messages]) => {
        if(i18n.locale === locale) {
            i18n.mergeLocaleMessage(locale, messages)
        }
    })
}

const messages = {}
locales.forEach(([locale, value]) => {
    messages[locale] = value
})

export const i18nOption = {
    local:currentLocal,
    messages
}
